import React from "react";
import Button from "@mui/material/Button";
const CustomPrimaryButton = ({
  label,
  additionalStyles,
  disabled,
  onClick,
}) => {
 
  return (
    <Button
      variant="contained"
      sx={{
        bgcolor: "#5865F2",
        color: "white",
        textTransform: "none",
        fontSize: "16px",
        fontWeight: 600,
        width: "100%",
        height: "40px",
        '&:disabled': {
          bgcolor: "#5865F2",
        color: "white",
        }
      }}
      style={additionalStyles ? additionalStyles : {}}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
      </Button>
  );
};

export default CustomPrimaryButton;
